<tcc-mono-dialog-layout
  [title]="'Selecteer een stal'"
  [displayBottomButtons]="false"
  [displaySearch]="true"
  (onSearch)="setQ($event)"
>
  <ion-content>
    <tcc-mono-stacked-list
      [items]="stables$ | async"
      [listItems]="listItem"
      (itemClicked)="selectGroup($event)"
      [selectedItem]="stable"
      (loadData)="loadData($event)"
    ></tcc-mono-stacked-list>
  </ion-content>
</tcc-mono-dialog-layout>
